import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ReflectionStateController } from '../../services/reflection-state.js';

@customElement('cp-reflection-badge')
export class CpReflectionBadge extends LitElement {
  createRenderRoot() { return this; }

  private _reflectionState = new ReflectionStateController(this);

  connectedCallback(): void {
    super.connectedCallback();
    void this._reflectionState.refreshCount();
  }

  private _onClick(): void {
    this.dispatchEvent(new CustomEvent('reflection-badge-click', {
      bubbles: true,
      composed: true,
    }));
  }

  render() {
    const count = this._reflectionState.unprocessedCount;
    if (count === 0) return nothing;

    return html`
      <button
        class="cp-reflection-badge__button"
        @click=${this._onClick}
        title="${count} unverarbeitete Notizen"
      >
        <svg class="cp-reflection-badge__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
        </svg>
        <span class="cp-reflection-badge__count">${count}</span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-reflection-badge': CpReflectionBadge;
  }
}
